import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';
import TableUser from '../../components/TableUser';

/* ===== Dashboard Card ===== */
function DashCards(props) {
  return (
    <div className="stats-card bg-white box-hover transition-all-1s animate__animated animate__fadeInDown">
      <div className="stats-title mb-4">{props.title}</div>

      <div className="stats-content d-flex flex-row">
        <div className="theme-color font-weight-bold m-1 stats-icon">
          <i className="fa fa-money"></i>
        </div>
        <div className="stat-nums m-1">
          <b>{props.number}</b>
        </div>
        <div className="stats-bar m-1"></div>
      </div>
    </div>
  );
}

/* ===== Main Page ===== */
export default function Subscriptions() {

  /* ---- Dump subscription data ---- */
  const [subscriptions, setSubscriptions] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState("R0");

  useEffect(() => {
    const dumpData = [
      {
        id: 1,
        trade_name: "Alpha Trades",
        email: "alpha@trades.com",
        amount: 299,
        date: "2026-01-10"
      },
      {
        id: 2,
        trade_name: "Market Pro",
        email: "info@marketpro.co.za",
        amount: 499,
        date: "2026-01-15"
      },
      {
        id: 3,
        trade_name: "Zulu FX",
        email: "support@zulufx.com",
        amount: 199,
        date: "2026-01-22"
      }, {
        id: 5,
        trade_name: "Zulu FX",
        email: "support@zulufx.com",
        amount: 199,
        date: "2026-01-22"
      }
    ];

    setSubscriptions(dumpData);

    const total = dumpData.reduce((sum, item) => sum + item.amount, 0);
    setTotalRevenue(`R${total}`);
  }, []);

  /* ---- Card ---- */
  const Cards = [
    { id: 1, title: "Total Revenue", number: totalRevenue }
  ];

  /* ---- Table headers ---- */
  const table_headers = [
    { id: 1, name: "ID" },
    { id: 2, name: "Trade Name" },
    { id: 3, name: "Email" },
    { id: 4, name: "Amount" },
    { id: 5, name: "Date" },
    { id: 6, name: "Manage" }
  ];

  /* ---- Table buttons (ONLY Export) ---- */
  const buttons = [
    { id: 1, title: "Export", path: "exportsubscriptions" }
  ];

  return (
    <>
      <div className="mr-0 ml-0 p-2 mt-2 mb-0">
        <h3>Subscriptions</h3>
      </div>

      {/* Cards */}
      <Container fluid className="d-flex flex-row mt-2 w-100 home-cards">
        {Cards.map(card => (
          <DashCards
            key={card.id}
            title={card.title}
            number={card.number}
          />
        ))}
      </Container>

      {/* Table */}
      <TableUser
        name="Subscriptions"
        table_headers={table_headers}
        members={subscriptions}
        buttons={buttons}
      />
    </>
  );
}
